import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone, I'm{" "}
            <span className="purple">
              <b>Mujeeb Khan</b>
            </span>
            <br />
            🎓B.Tech Student – Computer Science & Engineering (Data Science),
            <strong> Batch: 2024–2028</strong>
            <br />
            🏫 Ballari Institute of Technology and Management
            <br />
            📍 Karnataka, India
            <br />
            <br />
            I’m a devoted and curious tech enthusiast currently pursuing my
            B.Tech in Computer Science and Engineering with a specialization in
            Data Science. I enjoy working with data, building smart systems, and
            using technology to solve meaningful problems.
            <br />
            <br />
            Apart from coding, I love:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight />
              🌍 Exploring Technology
            </li>
            <li className="about-activity">
              <ImPointRight />
              📜 Reading Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> 🌄 Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)", fontStyle: "italic" }}>
            "Transform your learning into tools people love to use!"
          </p>
          <footer className="blockquote-footer">Mujeeb Khan</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
